const lightVentures = {
  snapp: {
    default: "#22A958",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 64.29%, #6EF7B7 100%)",
      background: "linear-gradient(180deg, #00FF89 0%, #00B964 100%)"
    }
  },
  express: {
    default: "#FF7300",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 61.46%, #FFAB66 100%)",
      background: "linear-gradient(180deg, #FFD5B3 0%, #FF8929 100%)"
    }
  },
  room: {
    default: "#FD531F",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 66.67%, #FFBB9B 100%)",
      background: "linear-gradient(180deg, #FFBB9B 0%, #FF5100 100%)"
    }
  },
  trip: {
    default: "#FF201B",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 67.71%, #FF9D9B 100%)",
      background: "linear-gradient(180deg, #FF9E9C 0%, #F80400 100%)"
    }
  },
  covid: {
    default: "#FF4D5E",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 62.5%, #FF7A87 100%)",
      background: "linear-gradient(180deg, #FFB3BA 0%, #FF3D50 100%)"
    }
  },
  food: {
    default: "#FF00A6",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 61.98%, #FF94D1 100%)",
      background: "linear-gradient(180deg, #FF94D1 0%, #F340A7 100%)"
    }
  },
  shop: {
    default: "#C400B4",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 68.75%, #FF9EFC 100%)",
      background: "linear-gradient(180deg, #F45FF0 0%, #C400B4 81.77%)"
    }
  },
  ticket: {
    default: "#6F1EC3",
    gradient: {
      foreground: "linear-gradient(360deg, #B783EC 0%, #FFFFFF 33.93%)",
      background: "linear-gradient(180deg, #BA83FF 0%, #7C3BCC 100%)"
    }
  },
  market: {
    default: "#1647FF",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 67.63%, #7A87FF 100%)",
      background: "linear-gradient(180deg, #7A87FF 0%, #3142E5 100%)"
    }
  },
  finTech: {
    default: "#008EFA",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 67.63%, #95D3FF 100%)",
      background: "linear-gradient(180deg, #96D3FF 0%, #0091FA 100%)"
    }
  },
  doctor: {
    default: "#00C5FF",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 61.46%, #B5E3FC 100%)",
      background: "linear-gradient(180deg, #B5E3FC 0%, #58C0F9 100%)"
    }
  },
  club: {
    default: "#FFCE00",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 60.94%, #FBE35C 100%)",
      background: "linear-gradient(180deg, #FFE05C 0%, #FAB300 100%)"
    }
  },
  lenz: {
    default: "#FFAF00",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 60.42%, #FFCF66 100%)",
      background: "linear-gradient(180deg, #FFE7B3 0%, #FFB71A 100%)"
    }
  },
  group: {
    default: "#6D6E70",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 60.42%, #98999A 100%)",
      background: "linear-gradient(180deg, #D8D9D9 0%, #88898B 100%)"
    }
  },
  safety: {
    default: "#039BE5",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 60.42%, #7CDEFD 100%)",
      background: "linear-gradient(180deg, #B8E4F9 0%, #03AAFC 100%)"
    }
  },
  sos: {
    default: "#F44336",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 60.42%, #F88981 100%)",
      background: "linear-gradient(180deg, #FBB9B6 0%, #F4443E 100%)"
    }
  },
  charity: {
    default: "#D9004F",
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 60.42%, #FF80AE 100%)",
      background: "linear-gradient(180deg, #FFB3CE 0%, #FA005B 100%)"
    }
  }
};
const darkVentures = {
  snapp: {
    get default() {
      return "#44D980";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 64.29%, #93F2B9 100%)",
      background: "linear-gradient(180deg, #93F2B9 0%, #44D980 100%)"
    }
  },
  express: {
    get default() {
      return "#FF7B0F";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 61.46%, #FFC799 100%)",
      background: "linear-gradient(180deg, #FFC799 0%, #FF7B0F 100%)"
    }
  },
  room: {
    get default() {
      return "#FE7B53";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 66.67%, #FFCBB3 100%)",
      background: "linear-gradient(180deg, #FFCBB3 0%, #FE7B53 100%)"
    }
  },
  trip: {
    get default() {
      return "#FF7875";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 67.71%, #FFB9B8 100%)",
      background: "linear-gradient(180deg, #FFB9B8 0%, #FF7875 100%)"
    }
  },
  covid: {
    get default() {
      return "#F79BA4";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 62.5%, #FFD1D5 100%)",
      background: "linear-gradient(180deg, #FFD1D5 0%, #F79BA4 100%)"
    }
  },
  food: {
    get default() {
      return "#FF6BCB";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 61.98%, #FFB3DE 100%)",
      background: "linear-gradient(180deg, #FFB3DE 0%, #FF6BCB 100%)"
    }
  },
  shop: {
    get default() {
      return "#FF5CF2";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 68.75%, #F8A0F6 100%)",
      background: "linear-gradient(180deg, #F8A0F6 0%, #FF5CF2 81.77%)"
    }
  },
  ticket: {
    get default() {
      return "#BC8CED";
    },
    gradient: {
      foreground: "linear-gradient(360deg, #D7B8FF 0%, #FFFFFF 33.93%)",
      background: "linear-gradient(180deg, #D7B8FF 0%, #BC8CED 100%)"
    }
  },
  market: {
    get default() {
      return "#1647FF";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 67.63%, #C2C8FF 100%)",
      background: "linear-gradient(180deg, #C2C8FF 0%, #859EFF 100%)"
    }
  },
  finTech: {
    get default() {
      return "#38A9FF";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 67.63%, #96D3FF 100%)",
      background: "linear-gradient(180deg, #96D3FF 0%, #0091FA 100%)"
    }
  },
  doctor: {
    get default() {
      return "#00C5FF";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 61.46%, #B5E3FC 100%)",
      background: "linear-gradient(180deg, #B5E3FC 0%, #58C0F9 100%)"
    }
  },
  club: {
    get default() {
      return "#FFCE00";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 60.94%, #FFE05C 100%)",
      background: "linear-gradient(180deg, #FFE05C 0%, #FAB300 100%)"
    }
  },
  lenz: {
    get default() {
      return "#FFAF00";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 60.42%, #FFCF66 100%)",
      background: "linear-gradient(180deg, #FFE7B3 0%, #FFB71A 100%)"
    }
  },
  group: {
    get default() {
      return "#A2A3A5";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 60.42%, #D6D6D6 100%)",
      background: "linear-gradient(180deg, #D6D6D6 0%, #A2A3A5 100%)"
    }
  },
  safety: {
    get default() {
      return "#03AAFC";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 60.42%, #B8E4F9 100%)",
      background: "linear-gradient(180deg, #B8E4F9 0%, #03AAFC 100%)"
    }
  },
  sos: {
    get default() {
      return "#F44336";
    },
    gradient: {
      foreground: " linear-gradient(180deg, #FFFFFF 60.42%, #FBBAB7 99.99%, #FBB9B6 100%)",
      background: "linear-gradient(180deg, #FBB9B6 0%, #F77C73 100%)"
    }
  },
  charity: {
    get default() {
      return "#FF70A4";
    },
    gradient: {
      foreground: "linear-gradient(180deg, #FFFFFF 60.42%, #FFB3CE 100%)",
      background: "linear-gradient(180deg, #FFB3CE 0%, #FF70A4 100%)"
    }
  }
};

export { darkVentures, lightVentures };
